import { defineRule } from 'vee-validate';

export const warningsDE: Record<string, string> = {
  'Straight rows of keys are easy to guess': 'Gerade Tastaturreihen sind leicht zu erraten.',
  'Short keyboard patterns are easy to guess': 'Kurze Tastaturmuster sind leicht zu erraten.',
  'Repeats like "aaa" are easy to guess': 'Wiederholungen wie "aaa" sind leicht zu erraten.',
  'Repeats like "abcabcabc" are only slightly harder to guess than "abc"': 'Wiederholungen wie "abcabcabc" sind kaum schwerer zu erraten als "abc".',
  'Sequences like abc or 6543 are easy to guess': 'Sequenzen wie "abc" oder "6543" sind leicht zu erraten.',
  'Recent years are easy to guess': 'Aktuelle Jahreszahlen sind leicht zu erraten.',
  'Dates are often easy to guess': 'Daten (z. B. Geburtstage) sind oft leicht zu erraten.',
  'This is a top-10 common password': 'Dies ist eines der 10 am häufigsten verwendeten Passwörter.',
  'This is a top-100 common password': 'Dies ist eines der 100 am häufigsten verwendeten Passwörter.',
  'This is a very common password': 'Dies ist ein sehr häufig verwendetes Passwort.',
  'This is similar to a commonly used password': 'Dieses Passwort ist einem häufig verwendeten Passwort sehr ähnlich.',
  'A word by itself is easy to guess': 'Ein einzelnes Wort ist leicht zu erraten.',
  'Common names and surnames are easy to guess': 'Namen allein sind leicht zu erraten.'
}

export const suggestionsDE: Record<string, string> = {
  'Add another word or two. Uncommon words are better.': 'Fügen Sie ein oder zwei weitere Wörter hinzu. Ungewöhnliche Wörter sind besser.',
  'Avoid repeated words and characters': 'Vermeiden Sie wiederholte Wörter und Zeichen.',
  'Avoid sequences': 'Vermeiden Sie Zeichenfolgen mit vorhersehbarer Reihenfolge.',
  'Avoid recent years': 'Vermeiden Sie aktuelle Jahreszahlen.',
  'Avoid years that are associated with you.': 'Vermeiden Sie Jahreszahlen, die mit Ihrer Person in Verbindung stehen.',
  'Avoid dates and years that are associated with you': 'Vermeiden Sie Daten oder Jahreszahlen, die mit Ihrer Person in Verbindung stehen.',
  'Capitalization doesn\'t help very much': 'Großschreibung allein verbessert die Sicherheit kaum.',
  'All-uppercase is almost as easy to guess as all-lowercase': 'Nur Großbuchstaben sind fast so leicht zu erraten wie nur Kleinbuchstaben.',
  'Reversed words aren\'t much harder to guess.': 'Umgedrehte Wörter sind kaum schwerer zu erraten.',
  'Predictable substitutions like \'@\' instead of \'a\' don\'t help very much': 'Ersetzungen wie "@" statt "a" helfen kaum.'
}


export default defineNuxtPlugin((nuxtApp) => {
/**
 * Most of these are COPYPASTA(https://briankoberlein.com/blog/copy-pasta/copypasta.jpg) 
 * from https://vee-validate.logaretm.com/v4/guide/global-validators/
 */
    defineRule('required', (value: string | any[]) => {
        if (!value || !value.length) {
            return 'Bitte geben Sie einen Wert ein';
        }
        return true;
    });
    defineRule('requiredCheckbox', (value: Boolean | any[]) => {
        if (value !== true) {
            return 'Bitte akzeptieren';
        }
        return true;
    });
    defineRule('email', (value: string) => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        // Check if email
        if (!(value.match(/^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,63}$/))) {
            return 'Bitte geben Sie eine gültige E-Mail Adresse ein';
        }
        return true;
    });
    defineRule('number', (value: string) => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        // Check if zip
        if (!(value.match(/^\d+$/))) {
            return 'Es sind nur Zahlen erlaubt';
        }
        return true;
    });
    defineRule('zip', (value: string) => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        if (value.length < 5) {
            return 'Bitte vervollständige die Eingabe';
        }
        // Check if zip
        if (!(value.match(/\b\d{5}\b/))) {
            return 'Die Postleitzahl ist ungültig';
        }
        return true;
    });
    defineRule('houseNumber', (value: string) => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        // Check if zip
        if (!(value.match(/^[0-9]{1,}[\sa-zA-Z0-9\/,_.\-]*$/))) {
            return 'Die Hausnummer ist ungültig';
        }
        return true;
    });
    defineRule('city', (value: string) => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        // Check if zip
        if (!(value.match(/^[a-zA-ZäÄöÖüÜß][a-zA-ZäÄöÖüÜß. ()\\-]*$/))) {
            return 'Die Stadt ist ungültig';
        }
        return true;
    });
    defineRule('street', (value: string) => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        // Check if valid street name (allows starting with letter or digit)
        if (!(value.match(/^[a-zA-ZäÄöÖüÜß0-9][a-zA-ZäÄöÖüÜß0-9-_()\\. ]*$/))) {
            return 'Die Straße ist ungültig';
        }
        return true;
    });
    defineRule('min', (value: string, [limit]: any) => {
        // The field is empty so it should pass
        if (!value || !value.length) {
          return true;
        }
        if (value.length < limit) {
          return `Bitte geben Sie mindestens ${limit} Zeichen ein`;
        }
        return true;
    });
    defineRule('zipDenyForCurrentBins', (value: string, notOneOf: array) => {
        // The field is empty so it should pass
        if (!value || !value.length) {
          return true;
        }
        if (notOneOf.includes(value)) {
          return `Ihre ausgewählte Postleitzahl ist außerhalb unseres Liefergebiets`;
        }
        return true;
    });
    defineRule('max', (value: string, [limit]: any) => {
        if (!value || !value.length) {
          return true;
        }
        if (value.length > limit) {
          return `Bitte geben Sie maximal ${limit} Zeichen ein`;
        }
        return true;
    });
    defineRule('isPackstation', (value: string) => {
        // The field is empty so it should pass
        if (!value || !value.length) {
            return true;
        }
        const lowerCaseValue = value.toLowerCase();
        const packstationSynonyms = ["packstation", "paketshop", "postfachanschrift", "postfach", "poststation"];
        for (const synonym of packstationSynonyms) {
            if (lowerCaseValue.includes(synonym)) {
                return `Ausgeschlossen: Postfachanschriften und Packstationen.`;
            }
        }
        return true;
    });
    defineRule('salutation', (value: string) => {
        // The field is empty so it should pass
        if (!value || !value.length) {
            return true;
        }
        switch (value) {
            case 'MR':
            case 'MS':
            case 'DIVERSE':
            case 'COMPANY':
            case 'FAMILY':
                return true
            default:
                return `Bitte wählen Sie einen Eintrag aus der Liste`;
        }
    });
    defineRule('equal', (value: string, [same, name]: [string, string]) => {
        if (!value || !value.length) {
          return true;
        }
        if (same?.startsWith('\\')) {
            same = same.slice(1);
        }
        if (value != same) {
          return `Bitte geben Sie den gleichen Wert ein, wie in dem Feld ${name}`;
        }
        return true;
    });
    defineRule('dateRange', (value: string, [min, max]: [string, string]) => {
        console.log('dateRange rule')
        if (!value || !value.length) {
            return true;
        }

        const inputDate = new Date(value)
        const minDate = new Date(min)
        const maxDate = new Date(max)

        if (isNaN(inputDate.getTime())) {
            return 'Bitte geben Sie ein gültiges Datum ein'
        }
console.log(inputDate, minDate, maxDate, inputDate < minDate, inputDate > maxDate)
        if (inputDate < minDate || inputDate > maxDate) {
            return `Das Datum muss zwischen dem ${minDate.toLocaleDateString('de-DE')} und dem ${maxDate.toLocaleDateString('de-DE')} liegen`
        }

        return true
    })

})